import { css } from 'styled-components'

export const blinkStyles = css`
  animation: blink 2000ms steps(2, start) infinite;

  @keyframes blink {
    to {
      visibility: hidden;
    }
  }
`
